module.exports = __webpack_public_path__ + "static/media/banner-cinza-mobile.6451e2f4.png";